'use client';
import SmallStar from '@/app/_components/ui/icons/SmallStar.svg';
import Cart from '@/app/_components/ui/icons/Cart.svg';
import Plus from '@/app/_components/ui/icons/Plus.svg';
import Link from 'next/link';
import React from 'react';
import Price from '../share/Price';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import ProductListAddToCart from '../share/ProductListAddToCart';

import useCart from '@/app/_hooks/useCart';
import { usePathname } from 'next/navigation';

export default function ProductDefaultMobile({ product, index }) {
  const { cart, addToCart } = useCart();
  const [isProductInCart, setIsProductInCart] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [openBoxPrice, setOpenBoxPrice] = useState(null);
  const pathname = usePathname();
  const allPricesOutOfStock = product?.prices?.every(
    (price) => price.stock <= 0
  );

  useEffect(() => {
    // Find the price with the attribute "جعبا باز"
    if (pathname === '/open-box/' && product?.prices) {
      const openBoxPrice = product.prices.find((price) =>
        price.attributes.some((attr) => attr.value === 'جعبه باز')
      );
      if (openBoxPrice) {
        setOpenBoxPrice(openBoxPrice);
      }
    }
  }, [pathname, product]);

  useEffect(() => {
    if (cart && cart.items) {
      setIsProductInCart(
        cart.items.some((item) => item.price_id === product?.prices[0]?.id)
      );
    }
  }, [cart]);

  const addToCartHandler = async () => {
    let newItem = {
      number: 1,
      price_id: product.prices[0].id,
      variation: {
        product: {
          media: {
            thumb: product.media?.thumb,
          },
          slug: product.slug,
          title: product.title,
        },
        regular: product.prices[0].regular,
        sale: product.prices[0].sale,
      },
    };
    // dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    // dataLayer.push({
    //   event: 'add_to_cart',
    //   ecommerce: {
    //     currency: 'IRR',
    //     value: newItem.sale,
    //     items: [
    //       {
    //         item_id: newItem.price_id,
    //         item_name: newItem.title,
    //         discount: newItem.regular - newItem.sale,
    //         item_list_id: 'archive_list',
    //         item_list_name: pageType,
    //         price: newItem.sale,
    //         quantity: 1,
    //       },
    //     ],
    //   },
    // });

    try {
      setIsAddingToCart(true); // Set loading state to true
      await addToCart({ items: [newItem] });
    } finally {
      setIsAddingToCart(false); // Reset loading state after the addToCart action completes
    }
  };

  const productUrl = openBoxPrice
    ? `/product/${product.slug}?pCode=${openBoxPrice?.id}`
    : `/product/${product.slug}`;
  return (
    <>
      {product ? (
        <div
          className="product-item relative bg-white p-3  md:p-6
          border-light-gray-300 h-full"
        >
          <div className="flex justify-between">
            <div className=" flex z-10">
              {product.label_top && (
                <div
                  className={`absolute text-white text-tiny py-1 px-2 top-2 right-1 rounded-[20px] label id-${product.label_top.id}`}
                  style={{
                    backgroundColor: product.label_top.background_color,
                  }}
                >
                  <div className="flex items-center ">
                    <span
                      className="pl-1"
                      dangerouslySetInnerHTML={{
                        __html: product.label_top.icon,
                      }}
                    />
                    <span style={{ color: product.label_top.text_color }}>
                      {product.label_top?.title}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="product-rating">
              <span className="rating-icon text-xs">
                {product.score != 0 && (
                  <div className="flex items-center">
                    <SmallStar fill="#FFC308" />
                    <span className="pl-1">{product.score}</span>
                  </div>
                )}
              </span>
            </div>
          </div>
          <div className="flex w-full md:flex-col">
            {product.label_bottom && (
              <div
                className="absolute text-white text-tiny py-0.5 px-2 rounded-md bottom-4 right-2 z-10"
                style={{
                  backgroundColor: product.label_bottom.background_color,
                }}
              >
                <span style={{ color: product.label_bottom.text_color }}>
                  {product.label_bottom.title}
                </span>
              </div>
            )}
            <Link href={productUrl}>
              <div className="product-image relative pl-3.5 md:pl-0 md:py-6 ">
                <Image
                  src={product.media.thumb.full_path}
                  width={120}
                  height={110}
                  alt={product.media.thumb.alt}
                  loading={index < 3 ? 'eager' : 'lazy'}
                  priority={index == 0}
                />
                {product?.brand && product?.brand[0]?.thumb?.full_path && (
                  <div className="absolute top-0 max-w-50px left-0 w-[30px] h-[30px]">
                    <Image
                      src={product?.brand[0]?.thumb?.full_path}
                      height={50}
                      width={50}
                      alt="barghchi"
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                  </div>
                )}
              </div>
            </Link>
            <div className="product-info flex-1">
              <Link href={productUrl}>
                <div>
                  <h2 className="my-2.5 pb-2 pr-4 text-sm  ">
                    {product.title}
                  </h2>
                </div>
              </Link>
              <div className="os-product-price  flex justify-between items-center">
                {allPricesOutOfStock ? (
                  <div className="text-red-500">ناموجود</div>
                ) : (
                  <>
                    <div>
                      <Price price={openBoxPrice || product.prices[0]} />
                    </div>
                    {product.prices.length > 0 &&
                      product.prices[0].stock > 0 &&
                      !product.offline && (
                        <div className="border border-color-primary rounded-md p-1.5 bg-primary-25 cursor-pointer">
                          {isProductInCart ? (
                            <Link href="/checkout/cart" target="_blank">
                              <Cart stroke="#2A75BB" />
                            </Link>
                          ) : (
                            <>
                              {product.type === 'simple' ? (
                                <div
                                  className="relative z-20 "
                                  onClick={addToCartHandler}
                                >
                                  {isAddingToCart ? (
                                    <LoadingIcon />
                                  ) : (
                                    <Plus stroke="#2A75BB" />
                                  )}
                                </div>
                              ) : (
                                <Link
                                  href={productUrl}
                                  className="relative z-20 "
                                >
                                  {isAddingToCart ? (
                                    <LoadingIcon />
                                  ) : (
                                    <Plus stroke="#2A75BB" />
                                  )}
                                </Link>
                              )}
                            </>
                          )}
                        </div>
                      )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
